// extracted by mini-css-extract-plugin
module.exports = {"dashedBorder":"style_dashedBorder__VQ5ku"};